(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-hybrid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click", function(e){

  if(e.target.closest(".hira-acc-title")){

    const title = e.target.closest(".hira-acc-title");
    const content = title.nextElementSibling;
    const icon = title.querySelector(".acc-icon");

    const isOpen = content.style.display === "block";

    if(isOpen){
      content.style.display = "none";
      icon.textContent = "+";
    } else {
      content.style.display = "block";
      icon.textContent = "−";
    }

  }

});


/* ============================= */
/* GALLERY THUMBNAIL SYNC */
/* ============================= */

const sliderWrapper = document.querySelector(".hira-slider-wrapper");
const thumbs = document.querySelectorAll(".hira-thumbs img");
const slides = document.querySelectorAll(".hira-slide");

function goToSlide(index) {
  if (!sliderWrapper || !slides[index]) return;
  const slideWidth = slides[index].offsetWidth;
  sliderWrapper.scrollTo({ left: slideWidth * index, behavior: "smooth" });

  thumbs.forEach(t => t.classList.remove("active"));
  if (thumbs[index]) thumbs[index].classList.add("active");
}

thumbs.forEach(function(thumb) {
  thumb.addEventListener("click", function() {
    const index = parseInt(this.getAttribute("data-index"));
    goToSlide(index);
  });
});

// Sync active thumb when user swipes the main slider
if (sliderWrapper) {
  sliderWrapper.addEventListener("scroll", function() {
    if (!slides.length) return;
    const slideWidth = slides[0].offsetWidth;
    const index = Math.round(sliderWrapper.scrollLeft / slideWidth);

    thumbs.forEach(t => t.classList.remove("active"));
    if (thumbs[index]) thumbs[index].classList.add("active");

    // Keep active thumb visible in the strip
    if (thumbs[index]) {
      thumbs[index].scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  });
}
/* ============================= */
/* VIDEO MODAL + AJAX CART */
/* ============================= */

const hiraModal = document.getElementById("hiraVideoModal");
const hiraModalVideo = document.getElementById("hiraModalVideo");

document.querySelectorAll(".hira-video-slide").forEach(function(slide){

  const sliderVideo = slide.querySelector("video");

  slide.addEventListener("click", function(e){

    if(e.target.closest(".hira-video-overlay")){
      const variantId = slide.querySelector(".hira-video-overlay").dataset.variantId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(() => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      });

      return;
    }

    if(!sliderVideo) return;

    sliderVideo.pause();
    hiraModalVideo.src = sliderVideo.currentSrc || sliderVideo.src;
    hiraModal.classList.add("active");
    hiraModalVideo.play();
    document.body.style.overflow = "hidden";

  });

});

document.querySelector(".hira-video-close")?.addEventListener("click", function(){
  hiraModal.classList.remove("active");
  hiraModalVideo.pause();
  hiraModalVideo.src = "";
  document.body.style.overflow = "";
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-overlay-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const sliders = document.querySelectorAll(".product-overlay-slider");

  sliders.forEach(function (slider) {

    const track = slider.querySelector(".product-slider-track");
    const slides = slider.querySelectorAll(".product-slide");

    let index = 0;
    const total = slides.length;

    if (total <= 1) return;

    function updateSlide() {
      track.style.transform = "translateX(-" + (index * 100) + "%)";
    }

    /* === SWIPE SUPPORT === */
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    function startDrag(e) {
      isDragging = true;
      startX = e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
      track.style.transition = "none";
    }

    function drag(e) {
      if (!isDragging) return;
      currentX = e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
      const diff = currentX - startX;
      track.style.transform = "translateX(calc(" + (-index * 100) + "% + " + diff + "px))";
    }

    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = "transform 0.6s ease";

      const diff = currentX - startX;

      if (diff < -50 && index < total - 1) {
        index++;
      } else if (diff > 50 && index > 0) {
        index--;
      }

      updateSlide();
    }

    /* Touch */
    track.addEventListener("touchstart", startDrag);
    track.addEventListener("touchmove", drag);
    track.addEventListener("touchend", endDrag);

    /* Mouse (desktop drag) */
    track.addEventListener("mousedown", startDrag);
    track.addEventListener("mousemove", drag);
    track.addEventListener("mouseup", endDrag);
    track.addEventListener("mouseleave", endDrag);

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){

  /* === TAB SWITCH === */
  document.querySelectorAll(".products-tab-btn").forEach(function(btn){

    btn.addEventListener("click", function(){

      document.querySelectorAll(".products-tab-btn").forEach(b => b.classList.remove("active"));
      document.querySelectorAll(".products-tab-content").forEach(c => c.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(btn.dataset.tab).classList.add("active");

    });

  });

  /* === QUICK ADD === */
  document.querySelectorAll(".quick-add").forEach(function(btn){

    btn.addEventListener("click", function(){

      const variantId = btn.dataset.variantId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      }).then(() => {
        location.reload(); // replace later with theme drawer integration
      });

    });

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-videos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){

  /* === ADD TO CART === */
  document.querySelectorAll(".video-product-card").forEach(function(card){

    card.addEventListener("click", function(e){
      e.stopPropagation(); // prevent video click

      const variantId = card.dataset.variantId;
      if(!variantId) return;

      const form = document.createElement('form');
form.method = 'POST';
form.action = '/cart/add';

const input = document.createElement('input');
input.type = 'hidden';
input.name = 'id';
input.value = variantId;

form.appendChild(input);
document.body.appendChild(form);
form.submit();

    });

  });
/* === VIDEO MODAL LOGIC === */
const modal = document.getElementById("videoModal");
const modalVideo = document.getElementById("modalVideo");
const closeBtn = document.querySelector(".video-modal-close");

let activeSliderVideo = null;

document.querySelectorAll(".shop-video-slide").forEach(function(slide){

  const sliderVideo = slide.querySelector("video");

  slide.addEventListener("click", function(e){

    // If clicking product card, ignore
    if (e.target.closest(".video-product-card")) return;

    if (!sliderVideo) return;

    activeSliderVideo = sliderVideo;

    sliderVideo.pause();

    const source = sliderVideo.currentSrc || sliderVideo.src;

    modalVideo.src = source;
    modal.classList.add("active");
    modalVideo.play();

    document.body.style.overflow = "hidden";

  });

});

function closeModal(){
  modal.classList.remove("active");
  modalVideo.pause();
  modalVideo.src = "";
  document.body.style.overflow = "";

  if(activeSliderVideo){
    activeSliderVideo.play();
    activeSliderVideo = null;
  }
}

closeBtn.addEventListener("click", closeModal);
modal.querySelector(".video-modal-overlay").addEventListener("click", closeModal);
});

  } catch(e) { console.error(e); }
})();
})();
